/** Allowed username characters: letters, numbers, period, underscore. */
export const USERNAME_ALLOWED_PATTERN = /^[a-zA-Z0-9._]+$/;

/** Max username length (keeps ForaCare PID = practiceId + username within API limits). */
export const USERNAME_MAX_LENGTH = 13;

export const USERNAME_FORMAT_MESSAGE =
  'Username may only contain letters, numbers, periods (.), and underscores (_)';

export const USERNAME_MAX_LENGTH_MESSAGE =
  `Username must be ${USERNAME_MAX_LENGTH} characters or fewer`;

/** Strip disallowed characters and enforce max length while typing. */
export function sanitizeUsernameInput(value) {
  return String(value ?? '')
    .replace(/[^a-zA-Z0-9._]/g, '')
    .slice(0, USERNAME_MAX_LENGTH);
}

export function isUsernameFormatValid(value) {
  const trimmed = String(value ?? '').trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= USERNAME_MAX_LENGTH &&
    USERNAME_ALLOWED_PATTERN.test(trimmed)
  );
}

/**
 * Returns an error message, or null when format is valid.
 * Empty values are not validated here (callers handle required separately).
 */
export function getUsernameFormatError(value) {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return null;
  if (trimmed.length > USERNAME_MAX_LENGTH) {
    return USERNAME_MAX_LENGTH_MESSAGE;
  }
  if (!USERNAME_ALLOWED_PATTERN.test(trimmed)) {
    return USERNAME_FORMAT_MESSAGE;
  }
  return null;
}
